import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api/api.service';
import { DataAvailabilityInfo } from '../types/data-availability-info.type';

@Injectable({ providedIn: 'root' })
export class DataAvailabilityService {
  private cache = new Map<string, DataAvailabilityInfo>();

  constructor(private apiService: ApiService) {}

  async getDataAvailability(processGroupId?: string): Promise<DataAvailabilityInfo | null> {
    if (this.cache.has(processGroupId)) {
      return this.cache.get(processGroupId);
    }

    try {
      const datesWithData = await this.apiService.monitoring.getDatesWithData(processGroupId);
      const isValid = Array.isArray(datesWithData) && datesWithData.length > 0;
      const dataAvailabilityInfo = new DataAvailabilityInfo(datesWithData, isValid);
      this.cache.set(processGroupId, dataAvailabilityInfo);
      return dataAvailabilityInfo;
    } catch {
      return null;
    }
  }

  clear(): void {
    this.cache.clear();
  }
}
